export function formatPhoneNumber(input: any) {
    const numbers = input.value.replace(/\D/g, '')
    const formattedNumber =
        numbers
            .slice(0, 9)
            .match(/.{1,3}/g)
            ?.join(' ') || ''

    input.value = formattedNumber
}
